module.exports = "/_next/static/images/1-9455a225c9036cba43da3094b38eba17.jpg";